import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './simulation.module.css';

const SimuladorCard = ({ title, description, image, url, buttonText }) => {
  const navigate = useNavigate();

  const handleClick = () => navigate(url);

  return (
    <>
      {/* tipografía serif aplicada al árbol del componente */}
      <style>{`
        .sim-serif-root, .sim-serif-root * {
          font-family: Georgia, "Times New Roman", Times, serif;
          letter-spacing: 0.01em;
        }
      `}</style>

      <div
        className={`sim-serif-root ${styles.card}`}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
        role="button"
        aria-label={title}
      >
        <img src={image} alt={title} className={styles.cardImage} />
        <div className={styles.cardContent}>
          <h3>{title}</h3>
          <p>{description}</p>
          <button
            type="button"
            className={styles.cardButton}
            onClick={(e) => { e.stopPropagation(); handleClick(); }}
          >
            {buttonText || 'Ver Simulador'}
          </button>
        </div>
      </div>
    </>
  );
};

export default SimuladorCard;
